export const MAX_TTS_TEXT_LENGTH = 2000;

export const isMessageValidForAudio = (input: string, ttsIncludeNarration?: boolean): boolean => {
  if (!input) {
    return false;
  }

  let sanitized = input
    .replace(/\n/g, " ") // Replace new lines with a white space
    .replace(/\.{2,}/g, " ") // Replace three dots with a white space
    .replace(/’/g, "'") // Replace curly apostrophe with single quote
    .replace(/!{2,}/g, "!") // Replace two or more exclamation marks with a single exclamation mark
    .replace(/\?{2,}/g, "?") // Replace two or more question marks with a single question mark
    .replace(/'{2,}/g, "'") // Replace two or more single quotes with a single quote
    .replace(/_+/g, "_") // Replace multiple underscores with a single underscore
    .replace(/\*+/g, "*") // Replace multiple asterisks with a single asterisk
    .replace(/,+/g, ","); // Replace multiple commas with a single comma

  // only trim action text when user has disabled narration
  if (!ttsIncludeNarration) {
    sanitized = sanitized
      .replace(/\*.*?\*/g, "") // Remove content inside *
      .replace(/_.*?_/g, ""); // Remove content inside _ (underline)
  }

  const audioText = sanitized
    .replace(/[^\p{L}\p{M}\p{N}. ,:'!?]/gu, "") // Keep letters/marks/numbers from any script (incl. CJK) plus basic punctuation
    .replace(/ {2,}/g, " ") // Replace multiple spaces with a single space
    .trim();

  return audioText.length > 0 && audioText.length <= MAX_TTS_TEXT_LENGTH;
};
